import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 sm:p-6" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-100 p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 text-sm text-[#1D1D1F] leading-relaxed">
          We use cookies to enhance your experience. By continuing to use this site, you agree to our{' '}
          <Link to="/cookie-policy" className="text-[#007AFF] font-medium hover:underline">Cookie Policy</Link>.
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={decline}
            className="btn-secondary text-sm px-4 py-2"
            data-testid="cookie-decline-btn"
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="btn-primary text-sm px-5 py-2"
            data-testid="cookie-accept-btn"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
